var gplBam = gplBam || {};
gplBam.Tracking = function() {

	var $ = jQuery;

	// AUTO-INIT
	$(function() {
		// call public init() method
		gplBam.Tracking.init();
	});

	var obj = {
		init: function() {
			if(typeof gtag !== 'undefined') {
				$('[data-track-click]').click(function() {
					var obj = $(this).data('track-click');
					gtag('event', 'click',
						{
							'event_category': obj.event_category,
							'event_action': obj.event_action,
							'event_label': obj.event_label
						}
					);
				});
			}
		},

		send: function(category, action, label) {
			if(typeof gtag !== 'undefined') {
				gtag('event', 'click',
					{
						'event_category': category,
						'event_action': action,
						'event_label': label
					}
				);
			}
		},

		EOF: null
	};

	return obj;

}();

gplBam.Nav = function() {

	var $ = jQuery;

	// AUTO-INIT
	$(function() {
		// call public init() method
		gplBam.Nav.init();
	});

	var obj = {
		init: function() {
			var navs = $(".navs-modal a");
			navs.attr('data-toggle', 'modal');
			navs.attr('data-target', '#navsModal');
		},
		EOF: null
	};

	return obj;

}();

var $jq = jQuery.noConflict();
$jq(document).ready(function() {
	// hide next/prev buttons on edges
	$jq('#bio_articles_slider').on('init', function(event, slick, currentSlide) {
		$jq('.slick-prev').hide();
	});
	$jq('#bio_articles_slider').on('afterChange', function(event, slick, direction) {
		if(direction > 0) {
			$jq('.slick-prev').show();
		}
		if(direction === 0) {
			$jq('.slick-prev').hide();
			$jq('.slick-next').show();
		}
		if(slick.slideCount <= slick.currentSlide + slick.options.slidesToShow) {
			$jq('.slick-next').hide();
		}
	});
	$jq('#bio_articles_slider').slick({
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 806,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	})

	// $jq(".auto-resize-higher").fitText(1.2);

});


